import { render, staticRenderFns } from "./formation-category.component.vue?vue&type=template&id=7e0beff9&scoped=true&"
import script from "./formation-category.component.vue?vue&type=script&lang=ts&"
export * from "./formation-category.component.vue?vue&type=script&lang=ts&"
import style0 from "./formation-category.component.vue?vue&type=style&index=0&id=7e0beff9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0beff9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VIcon,VTooltip})
